import { selectFromTeamMemberDto } from '../../models';

export default selectFromTeamMemberDto()
  .uuid
  .email
  .fullname
  .roles((r) => r.id.name)
  .driverProfileInParentOrg
  .toString();
